import { render, staticRenderFns } from "./BaseTotalShow.vue?vue&type=template&id=06fb5788&scoped=true&"
import script from "./BaseTotalShow.vue?vue&type=script&lang=js&"
export * from "./BaseTotalShow.vue?vue&type=script&lang=js&"
import style0 from "./BaseTotalShow.vue?vue&type=style&index=0&id=06fb5788&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb5788",
  null
  
)

export default component.exports